/**
 * Types for the GraphQL CMS Contentful response.
 *
 * @note the deprecated types relate to the old dictionary implementation
 */

import type { Document } from '@contentful/rich-text-types';

export enum CmsContentfulTypename {
  contentComponent = 'ContentComponent',
  shortText = 'ShortText',
  richText = 'ContentTypeRichText',
  longText = 'LongText',
  link = 'KbAppLink',
  image = 'Image',
  number = 'Number',

  /**
   * @deprecated use `ContentfulContentComponent` related types
   */
  componentCollection = 'ComponentCollection',
  /**
   * @deprecated use `ContentfulContentComponent` related types
   */
  componentEntriesCollection = 'ComponentEntriesCollection',
  /**
   * @deprecated use `ContentfulContentComponent` related types
   */
  component = 'Component',
}

export interface ContentfulContentComponent {
  readonly __typename: CmsContentfulTypename.contentComponent;
  readonly id: string;
  readonly uiComponent: string;
  readonly translatedEntitiesCollection: {
    readonly items: ContentfulTranslatedEntity[];
  };
}

export interface CmsComponentCollection {
  readonly __typename: CmsContentfulTypename.componentCollection;
  readonly items: ContentfulContentComponent[];
}

export type ContentfulTranslatedEntity =
  | CmsContentfulShortText
  | CmsContentfulLongText
  | CmsContentfulRichText
  | CmsContentfulLink
  | CmsContentfulImage
  | CmsContentfulNumber;

export interface CmsContentfulShortText {
  readonly __typename: CmsContentfulTypename.shortText;
  readonly key: string;
  readonly value: string;
}
export interface CmsContentfulNumber {
  readonly __typename: CmsContentfulTypename.number;
  readonly key: string;
  readonly number: number;
}

interface CmsContentfulRichTextContent {
  readonly json: Document;
}

export interface CmsContentfulRichText {
  readonly __typename: CmsContentfulTypename.richText;
  readonly key: string;
  readonly content: CmsContentfulRichTextContent;
}
export interface CmsContentfulLongText {
  readonly __typename: CmsContentfulTypename.longText;
  readonly key: string;
  readonly value: string;
}

export interface CmsContentfulLink {
  readonly __typename: CmsContentfulTypename.link;
  readonly key: string;
  readonly text: string;
  readonly url: string;
}

export interface CmsContentfulImageData {
  readonly original_secure_url: string;
  readonly width: number;
  readonly height: number;
}

export interface CmsContentfulImage {
  readonly __typename: CmsContentfulTypename.image;
  readonly key: string;
  readonly img: CmsContentfulImageData[];
  readonly alt: string;
  readonly title: string;
}

export interface ProcessedCmsContentfulImage {
  readonly __typename: CmsContentfulTypename.image;
  readonly key: string;
  readonly img: CmsContentfulImageData;
  readonly alt: string;
  readonly title: string;
}

/**
 * @deprecated use `ContentfulContentComponent` related types
 */
export type CmsContentfulContentData =
  | CmsContentfulShortText
  | CmsContentfulImageData
  | CmsContentfulRichText
  | CmsContentfulLongText
  | CmsContentfulImage
  | CmsContentfulLink;

/**
 * @deprecated use `ContentfulContentComponent` related types
 */
export type CmsContentfulComponentItem =
  | CmsContentfulShortText
  | CmsContentfulLongText
  | CmsContentfulImage
  | CmsContentfulRichText
  | CmsContentfulComponent
  | CmsContentfulLink
  | CmsContentfulNumber;

/**
 * @deprecated use `ContentfulContentComponent` related types
 */
export type CmsContentComponentTypes =
  | CmsContentfulShortText
  | CmsContentfulLongText
  | CmsContentfulImage
  | CmsContentfulRichText
  | CmsContentfulLink
  | CmsContentfulNumber;

/**
 * @deprecated use `ContentfulContentComponent` related types
 */
export interface CmsContentfulComponentCollection {
  readonly __typename: CmsContentfulTypename.componentCollection;
  readonly items: [CmsContentfulComponent];
}

/**
 * @deprecated use `ContentfulContentComponent` related types
 */
export interface CmsContentfulComponent {
  readonly __typename: CmsContentfulTypename.component;
  readonly name: string;
  readonly entriesCollection: CmsContentfulComponentEntriesCollection;
}

/**
 * @deprecated use `ContentfulContentComponent` related types
 */
export interface CmsContentfulComponentEntriesCollection {
  readonly __typename: CmsContentfulTypename.componentEntriesCollection;
  readonly items: CmsContentfulComponentItem[];
}

/**
 * @deprecated use `ContentfulContentComponent` related types
 */
export interface CmsContentfulComponentCollectionResponse {
  items: {
    __typename: CmsContentfulTypename.componentCollection;
    entriesCollection: {
      __typename: string;
      items: CmsContentfulComponentItem[];
    };
  };
}

/**
 * @deprecated use `ContentfulContentComponent` related types
 */
export interface CmsContentfulComponentResponse {
  component: {
    __typename: string;
    entriesCollection: {
      __typename: string;
      items: CmsContentfulComponentItem[];
    };
  };
}

/**
 * @deprecated use `ContentfulContentComponent` related types
 */
export interface CmsTranslatedEntitiesCollection {
  items: Omit<CmsContentfulComponentItem, 'CmsComponent'>;
}

/**
 * @deprecated use `ContentfulContentComponent` related types
 */
export interface CmsContentfulComponentsCollection {
  componentsCollection: {
    items: CmsTranslatedEntitiesCollection;
  };
}
